/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of patdocss (patients) to display or load patdocss */


(function () {
  'use strict';
  angular.module('vcpatdocs')
    .component('aidelist', {
      restrict: 'E',
      bindings: {
        consultid: '<?'
      },
      template: `
        <div ng-show="vm.aides.length === 0" class="alert alert-info"><h4>Es wurden noch keine Verordnungen angelegt.</h4></div>
        <div ng-show="vm.aides.length > 0">
        <h2>Bestehende Hilfsmittelverordnungen</h2>
        <div ng-repeat="aide in vm.aides">
          <div class="row">
            <div class="col-sm-11"><h4>Überweisung</h4></div>
            <div class="col-sm-1">
              <button class="btn btn-danger" ng-click="vm.removeReferral(aide)" uib-tooltip="Verordnung löschen">
                <i class="fa fa-remove"></i>
              </button>
            </div>
          </div>
        
          <div class="row">
            <div class="col-xs-12">
              <dl class="dl-horizontal">
                <dt>An/zu</dt>
                <dd ng-bind="aide.to"></dd>
                <dt>Diagnose</dt>
                <dd ng-bind="aide.diag"></dd>
                <dt>Verordnung</dt>
                <dd>
                    <p ng-repeat="aide in aide.allvalues">{{aide}}</p>
                    <p>{{aide.aide}}</p>
                </dd>
                <dt>Datum</dt>
                <dd ng-bind="aide.refdate"></dd>
              </dl>
            </div>
          </div>
        </div>
        
        <!-- PDF Vorschau -->
        <a class="btn btn-info" target="_blank" ng-show="vm.aides.length"
           href="{{vm.previewurl}}">
          <i class="fa fa-eye"></i> PDF Vorschau
        </a>
        <div style="min-height:3cm">&nbsp;</div>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Patdocs', 'PatdocsHelper', 'vertxEventBusService', 'PrintHelper',
        function ($log, $http, Rlog, Patdocs, PatdocsHelper, vertxEventBusService, PrintHelper) {
          let vm = this;
          vm.removeReferral = removeReferral;

          vm.getPreviewUrl = getPreviewUrl;

          function getPreviewUrl() {
            PrintHelper.aidePreviewUrl(aides[0].patientid, vm.consultid);
          }

          vm.$onInit = function () {

            // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.patdocss)) {
              vm.patdocss = Patdocs.$search();
            }
          }; // $onInit()

          // vm.consultid might be late propagating, get consult on first change
          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.consultid) && angular.isDefined(changes.consultid.currentValue) && changes.consultid.currentValue.length > 0 ) {
                vm.consultid = changes.consultid.currentValue;
                Patdocs.$search({consultid: vm.consultid, active: true, type: 'aide'}).$then(function (aides) {
                  vm.aides = aides;
                  if (aides.length > 0) {
                    vm.previewurl = PrintHelper.aidePreviewUrl(aides[0].patientid, vm.consultid);
                  }
                }, function (err) {
                  $log.error('aides lookup failed: ', vm.consultid);
                  Rlog.error('patdocs', 'aidelist', 'aide lookup failed', {consultid: vm.consultid});
                });
              }
            }
          };

          function removeReferral(ref) {
            ref.active = false;
            ref.$save();
          }

          const patdocsUpdateHandler = function (message) {
            if (angular.isDefined(vm.aides)){
              vm.aides.$refresh().$then(function (aides) {
                vm.previewurl = PrintHelper.aidePreviewUrl(aides[0].patientid, vm.consultid);
                $log.debug('debug: aidelist refreshed patdocss');
              }, function (error) {
                $log.debug('debug: aidelist refresh patdocs failed: ', error);
              });
            }
          };

          vertxEventBusService.on('patdocs.update', {}, patdocsUpdateHandler);


          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('patdocs.update', {}, patdocsUpdateHandler);
          };

        }] // controller
    }); // component

  // klammerfriedhof
}());